const title = {

};

const collapse = {
  paddingTop: '10px',
  cursor: 'pointer',
  userSelect: 'none',
};

export default { title, collapse };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/SpeechAndLanguage/style/style.js